import { Subheading } from '@datacamp/le-shared-components';
import { ButtonGroup } from '@datacamp/waffles-button';
import { colors } from '@datacamp/waffles-tokens';
import React from 'react';
import { VideoResource } from './VideoResource';
import { jsx as ___EmotionJSX } from "@emotion/react";
const getComponent = resource => {
  if (resource.type === 'VIDEO') {
    return ___EmotionJSX(VideoResource, resource.data);
  }
  return null;
};
export const Resources = _ref => {
  let {
    resources
  } = _ref;
  return ___EmotionJSX(ButtonGroup, null, resources.map(getComponent));
};
export const ResourceSection = _ref2 => {
  let {
    resources
  } = _ref2;
  if (resources.length > 0) {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Subheading, {
      iconName: "book"
    }, "Resources"), ___EmotionJSX("div", {
      style: {
        backgroundColor: colors.greyMedium,
        padding: 8
      }
    }, ___EmotionJSX(Resources, {
      resources: resources
    })));
  }
  return null;
};